import { GeoDsMeta } from "./meta-data.model";

export class BibMeasure extends GeoDsMeta{
  SeqNr: number;
  Title: string;
  SortNr?: number;
  Goal: string;
  Designation?: string;
  ParentId: string;
  constructor(data?) {
    super();
    Object.assign(this, data);
  }
}